
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabsforcorporateofficesinpune() {



    const cardData =
    {
        keyword: 'Cabs for Corporate Offices in Pune',
        heading: 'S9 Travels:  Cabs for Corporate Offices in Pune',
        headingDescription: 'S9 Travels provides Innova Cabs for Corporate Offices in Pune, offering a comfortable, reliable, and premium travel experience. Whether it is daily office commutes, business meetings, or executive travel, our well-maintained Innova cabs ensure a smooth and hassle-free ride. With spacious interiors, luxury features, and professional drivers, we guarantee timely and efficient transportation for corporate professionals. Choose S9 Travels for a seamless and stress-free corporate travel experience in Pune.',


        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada is a must-see for history buffs. This grand palace was once the seat of the Peshwa rulers and offers fascinating glimpses into Pune's royal past. The light and sound show in the evening is a popular attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892, this beautiful palace is known for its historical significance, as it served as a prison for Mahatma Gandhi during the Indian independence struggle. The palace is surrounded by lush gardens and serves as a reminder of India’s freedom movement."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. A popular trekking destination, it is also rich in history, having been the site of many battles, including the famous Battle of Sinhagad."
    },
    {
      "title": "Osho Ashram",
      "description": "For those seeking peace and tranquility, the Osho Ashram in Pune is a renowned spiritual retreat. It offers yoga, meditation, and spiritual practices to rejuvenate your mind and body. It’s an ideal place for those looking for a calm and reflective experience."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This ancient rock-cut temple, dedicated to Lord Shiva, is located right in the heart of Pune. Carved out of a single rock, it is a serene and historical place, providing insight into ancient Indian architecture and religion."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses a wide collection of artifacts, including sculptures, paintings, and other cultural exhibits. It showcases the rich artistic heritage of India, with a special emphasis on Maharashtra's traditional art forms."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "For nature lovers and those looking for a peaceful escape, Khadakwasla Dam offers a scenic location to relax. It’s a popular spot for picnics, and you can enjoy the beauty of the surrounding hills and the cool breeze by the water."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known as the heart of Pune's youthful and energetic vibe, Fergusson College Road is a bustling area filled with cafes, bookshops, and vibrant street markets. It’s a great spot to experience Pune’s lively culture and shop for souvenirs."
    },
    {
      "title": "Lal Mahal",
      "description": "A significant historical landmark, Lal Mahal was the residence of Chhatrapati Shivaji Maharaj during his youth. It’s an important monument that offers insights into the life of the great Maratha king."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully landscaped park is a peaceful retreat with lovely walking paths, koi ponds, and traditional Japanese architecture. It's an ideal place for a serene walk or a family outing."
    }
],

"services": [
    {
      "name": "Cabs for Corporate Offices in Pune",
      "description": "S9 Travels offers reliable and efficient cab services for corporate offices in Pune. Whether you need transportation for a few employees or a large team, we provide comfortable and punctual rides for daily office commutes."
    },
    {
      "name": "Book Corporate Office Taxis",
      "description": "Book corporate office taxis with S9 Travels for smooth and hassle-free transportation. We offer flexible booking options and ensure that your employees travel in comfort and arrive on time for work, meetings, or other office events."
    },
    {
      "name": "Pune Office Commute Cabs",
      "description": "Need a reliable cab service for your office commute in Pune? S9 Travels provides punctual and comfortable office commute cabs that ensure your employees start their day with a smooth ride to work. Ideal for daily commutes and work-related travel."
    },
    {
      "name": "Affordable Corporate Office Transportation in Pune",
      "description": "S9 Travels offers affordable corporate office transportation services in Pune without compromising on quality. We provide cost-effective solutions for office commutes, ensuring your employees travel comfortably and reliably every day."
    },
    {
      "name": "Executive Cabs for Office Travel in Pune",
      "description": "For executive-level office travel, S9 Travels offers premium executive cabs. Our fleet is equipped with luxury features to ensure top-level comfort and style for your executives during their daily office commutes or business meetings in Pune."
    },
    {
      "name": "Office Transportation Solutions in Pune",
      "description": "S9 Travels provides customized office transportation solutions in Pune, designed to meet the unique needs of your business. From regular office commutes to special transport requirements, we ensure a reliable and efficient service."
    },
    {
      "name": "Corporate Car Rental for Office Trips in Pune",
      "description": "Need a corporate car rental for office trips in Pune? S9 Travels offers flexible rental services for businesses, whether for a short trip or an extended period. Our fleet of well-maintained cars ensures comfort and safety for your office travel."
    },
    {
      "name": "Group Travel for Office Commutes",
      "description": "S9 Travels specializes in group travel for office commutes in Pune. Whether it's a small team or a large group, our spacious vehicles ensure that your entire team can travel together in comfort and arrive at their destination on time."
    },
    {
      "name": "Pune Office Employee Transport Service",
      "description": "S9 Travels offers a dedicated office employee transport service in Pune, ensuring safe, comfortable, and punctual travel for your staff. Whether for daily commuting or special office events, our service meets all your employee transport needs."
    },
    {
      "name": "Daily Office Shuttle Cabs in Pune",
      "description": "For daily office commutes, S9 Travels provides efficient and reliable shuttle cabs in Pune. Whether it's a one-way ride or a round trip, our shuttle cabs offer a convenient and cost-effective solution for employees to travel to and from work."
    },
    {
      "name": "Executive Office Car Hire",
      "description": "S9 Travels offers executive office car hire services for businesses in Pune. Whether it's for a high-level meeting, corporate event, or daily office commutes, our fleet of luxury cars ensures your executives travel in style and comfort."
    },
    {
      "name": "Office Pickup and Drop-off Services in Pune",
      "description": "S9 Travels provides reliable office pickup and drop-off services in Pune. Whether you're looking for transportation for your employees or clients, our punctual and professional drivers ensure a smooth and stress-free experience for your office trips."
    }
],

"tableData": [
  ["Cabs for Corporate Offices in Pune", "Book Corporate Office Taxis"],
  ["Pune Office Commute Cabs", "Affordable Corporate Office Transportation in Pune"],
  ["Executive Cabs for Office Travel in Pune", "Office Transportation Solutions in Pune"],
  ["Corporate Car Rental for Office Trips in Pune", "Group Travel for Office Commutes"],
  ["Pune Office Employee Transport Service", "Daily Office Shuttle Cabs in Pune"],
  ["Executive Office Car Hire", "Office Pickup and Drop-off Services in Pune"],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable and Punctual Daily Commutes",
    "WhyChoosedescription": "S9 Travels ensures reliable and punctual pick-up and drop-off services for corporate offices in Pune. Whether it's a daily commute or a business trip, our cabs are always on time, so your employees can focus on their work without worrying about transportation."
  },
  {
    "WhyChooseheading": "Comfort and Convenience for Employees",
    "WhyChoosedescription": "Our fleet of well-maintained vehicles, including the Toyota Innova, provides a comfortable and spacious environment for your employees. With air conditioning, ample legroom, and smooth rides, employees can relax and be ready for a productive day ahead."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced professionals who understand the importance of safety and punctuality for corporate transportation. They know the best routes in Pune, ensuring efficient and timely travel for your employees to and from their office."
  },
  {
    "WhyChooseheading": "Affordable Corporate Travel Packages",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for corporate offices in Pune. We provide affordable and customizable packages for regular office transportation, offering businesses great value while ensuring quality service and comfort for employees."
  },
  {
    "WhyChooseheading": "Secure and Safe Travel Options",
    "WhyChoosedescription": "Employee safety is a top priority at S9 Travels. Our cabs are equipped with modern safety features such as GPS tracking, airbags, and seat belts, ensuring your employees have a safe and secure journey to and from the office."
  },
  {
    "WhyChooseheading": "Flexible Scheduling for Corporate Needs",
    "WhyChoosedescription": "We offer flexible scheduling options to suit the needs of your corporate office. Whether you need rides for employees during rush hours or special travel arrangements for corporate events, S9 Travels can accommodate your requirements with ease."
  },
  {
    "WhyChooseheading": "24/7 Availability for Corporate Offices",
    "WhyChoosedescription": "S9 Travels provides round-the-clock service to corporate offices, ensuring that employees can travel at any time of the day or night. Whether it's for early morning shifts or late-night meetings, our cabs are always available."
  },
  {
    "WhyChooseheading": "Simple Booking and Account Management",
    "WhyChoosedescription": "Booking cabs for your corporate office is simple with S9 Travels. We offer easy-to-use booking options, whether online or through our app. We also provide businesses with account management services for convenient billing and travel monitoring."
  }
]








    }



    const faqData = [
        [
          {
            question: 'How can I book cabs for corporate offices in Pune with S9 Travels?',
            answer: 'Booking cabs for corporate offices is easy! You can book through our website or app, or simply get in touch with our customer service team to arrange regular transport for your office employees or clients.',
          },
          {
            question: 'What types of vehicles are available for corporate office transportation?',
            answer: 'We offer a variety of vehicles for corporate office transportation, including sedans, SUVs, and premium cars like the Toyota Innova, ensuring that your employees or clients travel in comfort and style.',
          },
          {
            question: 'Can I arrange daily office commute services for employees?',
            answer: 'Yes, we offer reliable daily office commute services for employees, ensuring timely pickups and drop-offs. We can arrange customized transport solutions to suit your office’s needs, whether it’s for a few employees or a larger group.',
          },
          {
            question: 'Are the drivers experienced for corporate office transport?',
            answer: 'Yes, our drivers are highly professional, experienced, and trained to offer the best corporate transport experience. They are punctual, courteous, and familiar with office routes, ensuring timely and smooth travel for your employees or clients.',
          },
          {
            question: 'Do you offer flexible timings for corporate office transportation?',
            answer: 'Yes, we offer flexible timings to accommodate early morning or late-night shifts. Whether your employees have varying work hours or you need transportation for special office events, we can adjust to your schedule.',
          },
          {
            question: 'Can I book cabs for client meetings or office events?',
            answer: 'Yes, we provide reliable transportation for client meetings, office events, and conferences. Our vehicles are well-maintained and perfect for providing a professional image to your clients and guests.',
          },
          {
            question: 'Is there a corporate discount for frequent office bookings?',
            answer: 'Yes, we offer exclusive corporate rates for businesses with regular transportation needs. Contact us to discuss your requirements, and we’ll provide a tailored pricing plan for your office’s transportation.',
          },
          {
            question: 'How do I ensure my corporate office bookings are always on time?',
            answer: 'We prioritize punctuality. Our drivers are trained to plan routes efficiently and monitor traffic, ensuring that your employees or clients are never late for meetings or office hours. We also offer real-time tracking for additional peace of mind.',
          },
          {
            question: 'Can I arrange transportation for office events or employee outings?',
            answer: 'Yes, we can arrange transportation for office events, employee outings, and team-building activities. Whether it’s a local trip or an out-of-town event, we ensure comfortable and reliable transport for your team.',
          },
          {
            question: 'Why should I choose S9 Travels for corporate office transportation in Pune?',
            answer: 'S9 Travels provides reliable, punctual, and professional corporate office transportation in Pune. With a fleet of well-maintained vehicles and experienced drivers, we ensure that your employees and clients enjoy a comfortable and smooth ride every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Kiran Deshmukh',
          designation: 'HR Head',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels has been handling our corporate office transport needs for over a year, and we’re extremely satisfied with their service. The vehicles are always clean, and the drivers are reliable and professional. It’s a great service for office commutes and client meetings!”',
        },
        {
          name: 'Ms. Priya Joshi',
          designation: 'Operations Manager',
          rating: [1, 1, 1, 1, 1],
          text: '“We’ve been using S9 Travels for our corporate office transport services, and their punctuality and professionalism have been outstanding. They take the stress out of office commuting, and their customer service is always responsive. Highly recommended for corporate transportation in Pune!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Cabs for Corporate Offices in Pune",
        "description": "Book affordable cabs for corporate offices in Pune, including office commutes, executive travel, and office pickup/drop-off services. S9 Travels offers reliable office transportation solutions, corporate car rentals, and group travel options for employees in Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    

    return (
        <div>
          <Helmet>
        <title>Cabs for Corporate Offices in Pune | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book cabs for corporate offices in Pune, including office commutes, executive car hire, and daily shuttle services. Affordable and reliable transportation solutions for employee transport and office trips in Pune with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      


<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabsforcorporateofficesinpune;